// extracted by mini-css-extract-plugin
module.exports = {"w1r7oec7":"w1r7oec7","s1q6y8ki":"s1q6y8ki"};